import Vue from 'vue';
import publicProfileTransformer from './../../transformers/publicProfile';
import store from './../../store';

const success = ({ data }, resolve) => {
  store.dispatch('getPublicProfile', publicProfileTransformer.fetch(data));

  resolve(publicProfileTransformer.fetch(data));
};

const failed = () => {};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('public_profile')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/publicProfile/show.js